import { render, staticRenderFns } from "./CmsHeaderImage.vue?vue&type=template&id=5063cfd0&scoped=true"
import script from "./CmsHeaderImage.vue?vue&type=script&lang=js"
export * from "./CmsHeaderImage.vue?vue&type=script&lang=js"
import style0 from "./CmsHeaderImage.vue?vue&type=style&index=0&id=5063cfd0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5063cfd0",
  null
  
)

export default component.exports